import React from "react";
import * as SurveyReact from "survey-react-ui";
import RadioOptionGrid from "../RadioOptionGrid";
import VisualIcon from "assets/icons/visual.svg";
import AuditoryIcon from "assets/icons/auditory.svg";
import ReadingIcon from "assets/icons/reading.svg";
import KinestheticIcon from "assets/icons/kinesthetic.svg";

interface RadioOption {
  value: string;
  title: string;
  description: string;
  icon?: string;
}

// Icon mapping for learning style options
const iconMapping: Record<string, string> = {
  Visual: VisualIcon,
  Auditory: AuditoryIcon,
  Reading: ReadingIcon,
  Kinesthetic: KinestheticIcon
};

class LearningStyleOptionGrid extends SurveyReact.SurveyQuestionRadiogroup {
  // Get radio options from survey definition
  private get radioOptions(): RadioOption[] {
    // Get the choices from the question
    const choices = this.question.choices || [];

    // Get the original survey definition to access full choice data
    const survey = this.question.survey;
    const questionDefinition = survey.getQuestionByName(
      this.question.name
    ) as any;
    const originalChoices =
      questionDefinition?.jsonObj?.choices || questionDefinition?.choices || [];

    // Map each choice to a full RadioOption using original survey data
    return choices.map((choice: any) => {
      const value = typeof choice === "string" ? choice : choice.value;

      // Find the original choice definition
      const originalChoice = originalChoices.find(
        (oc: any) => (typeof oc === "string" ? oc : oc.value) === value
      );

      const text =
        originalChoice && typeof originalChoice === "object"
          ? originalChoice.text
          : value;
      const description =
        originalChoice && typeof originalChoice === "object"
          ? originalChoice.description
          : "";
      const icon = iconMapping[value] || "";

      return {
        value: value,
        title: text,
        description: description,
        icon: icon
      };
    });
  }

  private handleSelectionChange = (value: string) => {
    this.question.value = value;
  };

  renderElement() {
    const options = this.radioOptions;
    return (
      <RadioOptionGrid
        options={options}
        selectedValue={this.question.value}
        onSelectionChange={this.handleSelectionChange}
      />
    );
  }
}

export default LearningStyleOptionGrid;
